import { useState } from "react";
import styled from "styled-components";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "components/Menu/Menu";
import Header from "components/Header/Header";
import Bio from "content/Bio/Bio";
import Work from "content/Work/Work";
import Performances from "content/Performances/Performances";
import Library from "content/Library/Library";
import Events from "content/Events/Events";
import Contact from "content/Contact/Contact";
import { LanguageContext } from "contexts/language.context";

const Layout = styled.div`
  display: flex;
  flex-direction: row;
`;

const Container = styled.div`
  height: 100vh;
  width: 100%;
  padding: 0 1rem 1rem 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  min-height: calc(100vh - 96px);
`;

function App() {
  const [language, setLanguage] = useState("EN");

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <BrowserRouter>
        <Layout>
          <Menu />
          <Container>
            <Header />
            <Content>
              <Routes>
                <Route exact path="/" element={<Bio />} />
                <Route path="/work" element={<Work />} />
                <Route path="/performances" element={<Performances />} />
                <Route path="/library" element={<Library />} />
                <Route path="/events" element={<Events />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Content>
          </Container>
        </Layout>
      </BrowserRouter>
    </LanguageContext.Provider>
  );
}

export default App;
